
import { Placement } from '@post-office/placements-frontend/statuspage-appearance-spotlight-placement';
export default Placement;
